import { Card, CardContent } from "@/components/ui/card"
import { Trophy, TrendingUp, Users, PieChart as PieChartIcon } from "lucide-react"
import type { RacePerformanceStat } from "./types"

interface PerformanceSummaryCardsProps {
  racePerformanceStats: RacePerformanceStat[]
}

export const PerformanceSummaryCards = ({ racePerformanceStats }: PerformanceSummaryCardsProps) => {
  const bestByPGW = [...racePerformanceStats].sort((a, b) => b.avgPGW - a.avgPGW)[0]
  const bestByOMW = [...racePerformanceStats].sort((a, b) => b.avgOMW - a.avgOMW)[0]

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <Card className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700">
        <CardContent className="p-3 sm:p-4">
          <div className="flex items-center justify-between">
            <div className="min-w-0 flex-1">
              <p className="text-xs sm:text-sm font-medium text-muted-foreground dark:text-gray-200 truncate">
                Mejor Raza (Puntos)
              </p>
              <p className="text-lg sm:text-xl font-bold text-gray-900 dark:text-gray-100 truncate">
                {racePerformanceStats[0]?.name}
              </p>
              <p className="text-xs text-muted-foreground dark:text-gray-300">
                {racePerformanceStats[0]?.avgPoints.toFixed(1)} pts promedio
              </p>
            </div>
            <Trophy className="h-6 w-6 sm:h-8 sm:w-8 text-yellow-500 flex-shrink-0" />
          </div>
        </CardContent>
      </Card>

      <Card className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700">
        <CardContent className="p-3 sm:p-4">
          <div className="flex items-center justify-between">
            <div className="min-w-0 flex-1">
              <p className="text-xs sm:text-sm font-medium text-muted-foreground dark:text-gray-200 truncate">
                Mejor PGW
              </p>
              <p className="text-lg sm:text-xl font-bold text-gray-900 dark:text-gray-100 truncate">
                {bestByPGW?.name}
              </p>
              <p className="text-xs text-muted-foreground dark:text-gray-300">
                {bestByPGW?.avgPGW.toFixed(1)}%
              </p>
            </div>
            <TrendingUp className="h-6 w-6 sm:h-8 sm:w-8 text-green-500 flex-shrink-0" />
          </div>
        </CardContent>
      </Card>

      <Card className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700">
        <CardContent className="p-3 sm:p-4">
          <div className="flex items-center justify-between">
            <div className="min-w-0 flex-1">
              <p className="text-xs sm:text-sm font-medium text-muted-foreground dark:text-gray-200 truncate">
                Mejor OMW
              </p>
              <p className="text-lg sm:text-xl font-bold text-gray-900 dark:text-gray-100 truncate">
                {bestByOMW?.name}
              </p>
              <p className="text-xs text-muted-foreground dark:text-gray-300">
                {bestByOMW?.avgOMW.toFixed(1)}%
              </p>
            </div>
            <Users className="h-6 w-6 sm:h-8 sm:w-8 text-blue-500 flex-shrink-0" />
          </div>
        </CardContent>
      </Card>

      <Card className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700">
        <CardContent className="p-3 sm:p-4">
          <div className="flex items-center justify-between">
            <div className="min-w-0 flex-1">
              <p className="text-xs sm:text-sm font-medium text-muted-foreground dark:text-gray-200 truncate">
                Razas Analizadas
              </p>
              <p className="text-xl sm:text-2xl font-bold text-gray-900 dark:text-gray-100">
                {racePerformanceStats.length}
              </p>
            </div>
            <PieChartIcon className="h-6 w-6 sm:h-8 sm:w-8 text-muted-foreground dark:text-gray-300 flex-shrink-0" />
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
